import React from "react";
import CareerWithAptechSection from "../components/CareersWithAptech/CareerWithAptech.tsx";
import MetaComponent from "../components/CommonComponents/MetaComponent.tsx";
const CareerWithAptech = () => {
  return (
    <div>
      <MetaComponent
        title="Vocational Education Jobs & Career Opportunities | Careers at Aptech Limited"
        desc="Explore rewarding careers in vocational education at Aptech Limited and join a global organization committed to skill development and professional growth."
        keywords="vocational training, career with aptech, job openings"
      />
      <CareerWithAptechSection />
    </div>
  );
};

export default CareerWithAptech;
